import {isNotNil} from 'ramda';

import {FALLBACK_LANGUAGE} from '@dms/i18n';

import {Nullish} from 'shared/web';

import {localeByLanguage} from '../constants/localeByLanguage';

// `localeByLanguage` is keyed by the short language codes that
// `/dms/v1/available-languages` returns, which is the only set of values the
// application ever persists as the last known language.
const SUPPORTED_LANGUAGES: ReadonlySet<string> = new Set(Object.keys(localeByLanguage));

// The persisted language comes from localStorage, so it is untrusted input for
// the catalogue API. Anything outside the supported set is discarded, including
// the literal string 'null' that the application once persisted.
const sanitizeStoredLanguage = (storedLanguage: string | Nullish): string | Nullish =>
  isNotNil(storedLanguage) && SUPPORTED_LANGUAGES.has(storedLanguage) ? storedLanguage : null;

export function resolveCatalogueLanguage(
  storedLanguage: string | Nullish,
  resolvedLanguage: string | Nullish
): string {
  // The resolved language comes from i18next itself, not from storage, so it is
  // used as-is. It can legitimately sit outside the supported set, for example
  // 'cimode' in end-to-end test runs.
  return (
    [sanitizeStoredLanguage(storedLanguage), resolvedLanguage].find(isNotNil) ?? FALLBACK_LANGUAGE
  );
}
